import { AuthError } from "firebase/auth";

const hasStringCode = (error: unknown): error is { code: string } => {
  return typeof error === "object" && error !== null && "code" in error && typeof error.code === "string";
};

export type IsFirebaseError = (error: unknown) => error is AuthError;

export const isFirebaseError: IsFirebaseError = (error): error is AuthError => {
  if (hasStringCode(error) && error.code.startsWith("auth/")) {
    return true;
  }

  return false;
};
